import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { map, shareReplay, combineLatestWith, tap } from 'rxjs/operators';

import {
  selectCanAcceptRecurring,
  selectSelectedCampaignVM,
  selectSelectedId,
  selectPopupCampaigns,
} from '../../state/campaing/selectors';

import {
  selectDonationType,
  selectPrice,
  selectShowCampaignsColumnPopup,
} from '../../state/donation-flow/selectors';

import { DonationFlowUiActions } from '../../state/donation-flow';
import { CampaignsActions } from '../../state/campaing/actions';

import { PriceDraft, DonationType } from '../../types/donation-flow.models';
import { CampaignSummaryComponent } from '../shared/campaign/summary/summary.component';
import { PopUpFormComponent } from './form/pop-up-form.component';
import { CampaignCarouselComponent } from '../shared/campaign/carousel/campaign-carousel.component';
import { PriceEnvelope } from '../../types/stripe-models';
import { ModalLayoutService } from '../../services/modal-layout.service';
import { ModalNavigationService } from '../../services/modal-navigation.service';

// const tapLog =
//   <T>(label: string) =>
//   (source: import('rxjs').Observable<T>) =>
//     source.pipe(tap((v) => console.log(`[PopUP] ${label}:`, v)));

const tapTable =
  <T extends any[]>(label = 'table') =>
  (source: import('rxjs').Observable<T>) =>
    source
      .pipe
      // tap((arr) => {
      //   console.log(
      //     `[PopUP] ${label} (len=${Array.isArray(arr) ? arr.length : 'n/a'})`
      //   );
      //   if (Array.isArray(arr)) console.table(arr);
      // })
      ();
@Component({
    selector: 'lib-donation-popup',
    imports: [
        CommonModule,
        CampaignSummaryComponent,
        PopUpFormComponent,
        CampaignCarouselComponent,
    ],
    templateUrl: './popup.component.html'
})
export class PopUPComponent implements OnInit {
  emailInfo = 'info@crezcofoundation.org';

  private store = inject(Store);
  private modalNav = inject(ModalNavigationService);
  private destroyRef = inject(DestroyRef);
  private layout = inject(ModalLayoutService);

  ngOnInit(): void {
    this.store.dispatch(CampaignsActions.load());
    this.layout.setSizeUntilDestroyed(
      'donation-compact',
      'small',
      this.destroyRef
    );
  }

  /** Selectores compartidos */
  canAcceptRecurring$ = this.store.select(selectCanAcceptRecurring);

  selectedCampaign$ = this.store
    .select(selectSelectedCampaignVM)
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  selectedCampaignSig = toSignal(this.selectedCampaign$, {
    initialValue: null,
  });

  draftPrice$ = this.store.select(selectPrice).pipe(
    combineLatestWith(this.store.select(selectDonationType)),
    map(([price, donationType]) => ({ ...price, donationType }))
  );

  showCampaignsCol$ = this.store.select(selectShowCampaignsColumnPopup);
  // .pipe(tapLog('showCampaignsCol$'), takeUntilDestroyed(this.destroyRef));

  campaigns$ = this.store
    .select(selectPopupCampaigns)
    .pipe(
      tapTable('campaigns$'),
      shareReplay({ bufferSize: 1, refCount: true }),
      takeUntilDestroyed(this.destroyRef)
    );

  selectedId$ = this.store.select(selectSelectedId);
  // .pipe(tapLog('selectedId$'), takeUntilDestroyed(this.destroyRef));
  // midColLgClass$ = this.showCampaignsCol$.pipe(
  //   map((show) => (show ? 'col-lg-6' : 'col-lg-8'))
  // );
  // donorsColLgClass$ = this.showCampaignsCol$.pipe(
  //   map((show) => (show ? 'col-lg-3' : 'col-lg-4'))
  // );

  onSelectCampaign = (id: string) => {
    this.store.dispatch(CampaignsActions.select({ id, source: 'user' }));
  };

  onPopUpSubmit = (formValue: PriceEnvelope) => {
    const data = formValue?.data;

    // Detecta recurring explícito
    const isRecurring =
      !!data?.recurring &&
      typeof data.recurring === 'object' &&
      !!(data.recurring as any).interval;

    const donationType: DonationType = isRecurring
      ? DonationType.Recurring
      : DonationType.OneTime;

    // 1) Snapshot del Campaign seleccionado
    const vm = this.selectedCampaignSig(); // CampaignVM | null
    const productId = vm?.productId ?? undefined;
    const productFeeId = vm?.productFeeId ?? undefined;

    const draft: PriceDraft = {
      action: 'Create',
      productId, // selectedCampaign.productId
      productFeeId, // selectedCampaign.productFeeId,
      currency: data?.currency,
      unitAmount:
        data?.unitAmount != null ? String(data.unitAmount) : undefined,
      nickname: data?.nickname,
      recurring: isRecurring ? data.recurring : undefined,
    };

    this.store.dispatch(
      DonationFlowUiActions.changeDonationType({ donationType })
    );
    this.store.dispatch(
      DonationFlowUiActions.setDonationType({ donationType })
    );
    this.store.dispatch(
      DonationFlowUiActions.setDeferFirstCharge({ isFirstChargeDeferred: false })
    );
    this.store.dispatch(
      DonationFlowUiActions.setFirstPaymentDate({ firstPaymentDate: null })
    );
    this.store.dispatch(DonationFlowUiActions.setPriceDraft({ draft }));

    this.modalNav.navigateToPaymentStep(donationType, 2);
  };
}
